import React from 'react';
export const StopIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.414 17.414L0.586 13.586C0.211 13.211 0 12.702 0 12.172V5.828C0 5.298 0.211 4.789 0.586 4.414L4.414 0.586C4.789 0.211 5.298 0 5.828 0H12.171C12.701 0 13.21 0.211 13.585 0.586L17.413 4.414C17.789 4.789 18 5.298 18 5.828V12.171C18 12.701 17.789 13.21 17.414 13.585L13 18H5.828C5.298 18 4.789 17.789 4.414 17.414ZM8.999 12.25L9.11569 12.2567C9.61337 12.3144 10 12.7367 10 13.25C10 13.8022 9.55221 14.25 9 14.25C8.44778 14.25 8 13.8022 8.00002 13.2554C7.99627 12.7375 8.38737 12.3105 8.88975 12.2559L8.999 12.25ZM9.74315 4.39823C9.69349 4.03215 9.3797 3.75 9 3.75C8.58579 3.75 8.25 4.08579 8.25 4.5V9.5L8.25685 9.60177C8.30651 9.96785 8.6203 10.25 9 10.25C9.41421 10.25 9.75 9.91421 9.75 9.5V4.5L9.74315 4.39823Z"
      fill="#CC2E3B"
    />
  </svg>
);
